<template>
  <div>
    <van-search
      v-model="value"
      label="客户"
      placeholder="请输入搜索关键词"
      input-align="center"
      show-action
      @search="onSearch"
    >
      <template #action>
        <div @click="onSearch">搜索</div>
      </template>
    </van-search>
    <van-pull-refresh v-model="loading" success-text="刷新成功" @refresh="query">
      <van-cell v-for="item in data" :key="item.id" :title="item.name"
                :value="item.sname" @click="handleClick(item)"
      />
    </van-pull-refresh>
    <van-col v-if="data.length === 0" :span="24" style="text-align: center; font-size: 14px; color: gray;">
      {{ CONST.EMPTY_MSG }}
    </van-col>
  </div>
</template>

<script>
import { getClientList } from '@/api/client'
export default {
  name: 'Upload',
  data() {
    return {
      loading: false,
      data: [],
      value: '',

      queryCondition: {
        page: this.CONST.PAGINATION.PAGE,
        rows: this.CONST.PAGINATION.MAX_ROWS,
        name: ''
      }
    }
  },
  methods: {
    query() {
      this.loading = true
      getClientList(this.queryCondition).then(resp => {
        this.data = resp.rows || []
        this.loading = false
      })
    },
    onSearch() {
      const keywords = this.value.trim()
      if (keywords && keywords.length >= 2) {
        this.queryCondition.name = keywords
        this.query()
      } else {
        this.toast('请您至少输入两个字进行检索')
      }
    },
    handleClick(item) {
      this.$store.dispatch('app/setSelectedClient', item)
      this.$router.push('/elecnotes/upload-file')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/elecnotes/upload.vue